
import type { ExplainScoreMessages } from '../../models'
import { RootScoreCriteriaTypeEnum } from '@empathybroker/tsclient-play/dist/enums/search/debug/result/score-criteria-detail-type.enum'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { useExplainBrowse } from '../../composables/explain/use-explain-browse'
import { ExplainUtils } from '../../utils/explain.utils'
import EpbLegend from '../legend.component.vue'

export default defineComponent({
  components: {
    EpbLegend,
  },
  setup() {
    const {
      proxy: { $epb },
    } = getCurrentInstance()
    const messages = $epb.messages.explain.score as ExplainScoreMessages

    const { isBrowseContext } = useExplainBrowse()

    const items = computed(() => {
      const filteredCriteriaTypes = Object.values(RootScoreCriteriaTypeEnum).filter(
        type => !isBrowseContext.value || type !== RootScoreCriteriaTypeEnum.TERM_POSITION,
      )

      return filteredCriteriaTypes.map((scoreCriteriaDetailType: RootScoreCriteriaTypeEnum) => {
        const scoreCriteriaDetailMessages = ExplainUtils.getResultScoreCriteriaDetailMessages(
          scoreCriteriaDetailType,
          messages,
        )
        return {
          label: scoreCriteriaDetailMessages.label,
          icon: ExplainUtils.getResultScoreCriteriaDetailIcon(scoreCriteriaDetailType),
          color: ExplainUtils.getResultScoreCriteriaDetailColor(scoreCriteriaDetailType),
          description: scoreCriteriaDetailMessages.description,
        }
      })
    })

    return {
      items,
    }
  },
})
